import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Campaign } from 'src/app/interfaces/campaign-interface';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
EventEmitter

@Component({
  selector: 'app-deposit-bonus-offers',
  templateUrl: './deposit-bonus-offers.component.html',
  styleUrls: ['./deposit-bonus-offers.component.scss'],
})
export class DepositBonusOffersComponent implements OnInit {

  @Output() selectedDepositBonusOffer = new EventEmitter<any>();

  public depositCode: any;
  public selectedBonusItem: string;
  public offers: any[] = [];
  public hideOffers: boolean = false;
  public emittedObject: { selectedbonusOffer: any };
  public thumbnailUrl: string;

  onlyDepositBonus = item => item.campaign_type == "DEPOSIT";

  constructor(
    public appLinksService: AppLinksService,
    public cashierContentService: CashierContentService,
    public events: EventsService,
    public rewardsService: RewardsService,
    public utilsService: UtilsService,
    private readonly config: ConfigService
  ) {
  }

  ngOnInit(): void {
    const baseURL: any = this.config.getConfig().CDN_BASEURL;
    this.thumbnailUrl = `${baseURL}/assets/notifications/`;
    
    this.onGetBonusOffers();
    this.cashierContentService.bonusOfferValue.subscribe(res => this.selectedBonusItem = res);
  }

  public onGetBonusOffers() {
    return new Promise((resolve: any, reject: any) => {
      this.rewardsService.callGetBonusOffers().subscribe((response: any) => {
        if (response && !!response.result) {
          const data = response.payload;
          this.offers = data.filter(this.onlyDepositBonus);

          // Filter out offers that need to be opted in, but weren't
          let doesNotRequireOptInAndNotOptedIn = item => !(item.requires_opt_in === true && item.opt_in !== true);
          this.offers = this.offers.filter(doesNotRequireOptInAndNotOptedIn);

          this.hideOffers = (this.offers.length == 1 && this.offers.filter((bonus) => {
            return bonus.campaign_code == "ZZ_NO_DEPOSIT";
          }).length == 1) ? true : false;

          this.selectBestOne(this.offers);

        }
      }, (error) => {
        console.error(error);
        resolve();
      });
    });
  }

  private selectBestOne(offer: Array<Campaign>) {
    let selBonus;
    if (this.selectedBonusItem != 'EMPTY_DEPOSIT_DEPOSIT'
      && offer.find(obj => {
        selBonus = obj;
        return obj.campaign_code == this.selectedBonusItem
      }) //check, if offer exist in the list already
    ) {
      this.onBonusSelect(selBonus)
      return;
    }

    const campaignID = this.utilsService.getCampaignId();
    const objectLength = String(offer.length - 1);

    if (offer && typeof offer != "undefined" && offer.length > 0) {
      if (!isUndefined(campaignID)) {
        let index = offer.map(e => e.id).indexOf(campaignID);
        return this.onBonusSelect(offer[index]);
      }

      for (let item in offer) {
        if (offer[item].tagline != null && ((offer[item].tagline).toUpperCase()).includes("DEFAULT")) {
          return this.onBonusSelect(offer[item]);
        }

        if (offer[item].campaign_code != null && ((offer[item].campaign_code).toUpperCase()).includes("ZZ_NO_DEPOSIT")) {
          return this.onBonusSelect(offer[item]);
        }
        if (item == objectLength) {
          return this.onBonusSelect(offer[0]);
        }
      }
    }
  }

  public openExternalLinks(url, title): any {
    return this.appLinksService.openPopover(url, title)
  }

  public onBonusSelect(offer) {
    this.selectedBonusItem = offer.campaign_code;
    this.cashierContentService.updateBonusOfferValue(this.selectedBonusItem);
    this.emitSelectBonus(offer);
    this.events.publish("event:bonusCTASelection", { selectedBonus: offer });
  }

  public emitSelectBonus(offer) {
    this.emittedObject = {
      selectedbonusOffer: offer
    }

    return this.selectedDepositBonusOffer.emit(this.emittedObject);
  }

}
